import * as React from 'react';
import Radium from 'radium';
import { Link, matchPath } from 'react-router-dom';

import { Navbar, NavItem, NavDropdown } from '@ihme/common/web/components';

import { HOME_PATH } from '../../router/paths';

type NavMenuItem = {
    key: string;
    action: string;
    title: string;
    disabled?: boolean;
    subItems?: NavMenuItem[];
};

type Props = {
    items: NavMenuItem[];
    location?: {
        pathname: string;
    };
    style?: React.CSSProperties;
};

type State = {
    windowWidth: number;
};

class View extends React.Component<Props, State> {
    state: State = {
        windowWidth: typeof window === 'undefined' ? 0 : window.innerWidth,
    };

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    renderNavItem = (item: NavMenuItem) => {
        const isHttpLink =
            item.action.indexOf('http://') !== -1 || item.action.indexOf('https://') !== -1;

        if (isHttpLink) {
            return (
                <NavItem
                    disabled={item.disabled}
                    key={item.key}
                    href={item.action}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {item.title}
                </NavItem>
            );
        }

        const pathname = this.props.location?.pathname ?? '';
        const isActive = !!matchPath(pathname, {
            path: item.action,
            exact: item.action === HOME_PATH,
        });

        return (
            <li key={item.key} role="presentation" className={isActive ? 'active' : ''}>
                <Link to={item.action}>{item.title}</Link>
            </li>
        );
    };

    renderDropDown = (menu: NavMenuItem) => (
        <NavDropdown id={`nav-dropdown-${menu.key}`} key={menu.key} title={menu.title}>
            {menu.subItems?.map(item => this.renderNavItem(item))}
        </NavDropdown>
    );

    renderTopNavItem = (item: NavMenuItem) => {
        const isHttpLink =
            item.action.indexOf('http://') !== -1 || item.action.indexOf('https://') !== -1;
        const pathname = this.props.location?.pathname ?? '';
        const isActive = !!matchPath(pathname, {
            path: item.action,
            exact: item.action === HOME_PATH,
        });

        if (isHttpLink) {
            return (
                <li key={item.key} className={isActive ? 'active' : ''}>
                    <a href={item.action} rel="noopener noreferrer" target="_blank">
                        {item.title}
                    </a>
                </li>
            );
        }

        return (
            <li key={item.key} className={isActive ? 'active' : ''}>
                <Link to={item.action}>{item.title}</Link>
            </li>
        );
    };

    renderNavigation = () => (
        <Navbar.Collapse style={{ padding: 0 }}>
            <ul className="nav navbar-nav navbar-right">
                {this.props.items.map(item =>
                    item.subItems ? this.renderDropDown(item) : this.renderTopNavItem(item)
                )}
            </ul>
        </Navbar.Collapse>
    );

    render() {
        const { windowWidth } = this.state;
        const { style } = this.props;

        return (
            <Navbar collapseOnSelect style={style}>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <img style={styles.logo} src="/img/logo.png" alt="" />
                            {windowWidth < 1200 && windowWidth >= 992
                                ? 'IHME'
                                : 'IHME Hepatitis Facts'}
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                {this.renderNavigation()}
            </Navbar>
        );
    }
}

const styles = {
    logo: {
        display: 'inline',
        marginRight: 7,
        marginLeft: 15,
        height: 26,
        marginTop: -6,
        /* sm */
        '@media (min-width: 768px)': {
            height: 26,
        },
        /* md */
        '@media (min-width: 992px)': {
            height: 26,
        },
    },
};

export default Radium(View);
